import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"
import moment from 'moment';

const headCells = [
    { id: 'numfactura', label: 'Nº FACTURA', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
    { id: 'fechaemision', label: 'FECHA EMISION', width: '120px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
    { id: 'descripcion', label: 'DECRIPCION', width: '560px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
    { id: 'CodigoGestor', label: 'CODIGO GESTOR', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
    { id: 'descripcion', label: 'NOMBRE GESTOR', width: '560px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
    { id: 'status', label: 'STATUS', width: '150px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
]


const TablaFacturasInmuebles = props => {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [activate, setActivate] = useState(false);
    let op = require('../../../../src/modulos/datos');


    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 320);

    const [url, setUrl] = useState('');

    useEffect(() => {

       if(props.facturaR){
           setRecords(props.facturaR)
       }


    }, [props.facturaR]);

    return (
        <div >
            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row" >

                            <div className="col-md-12 justify-content-center" >
                            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                    <TblHead />

                                    <tbody>
                                        {

                                            records && records.map((item, index) => (
                                                <tr key={item.numfact} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.numfact.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechaemi).format('DD/MM/YYYY')}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left" }}>{item.descrip.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.codges.trim()}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.nombgestor}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.estatus.trim()}</td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                {/*<TblPagination />*/}

                            </div>
                            <div align="center" className="col-md-12">
                                <a> &nbsp; </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaFacturasInmuebles;
